export default {"src":"/_next/static/media/rarraba-footer.939f78a5.svg","height":273,"width":1370,"blurWidth":0,"blurHeight":0};